import '../../../../assets/peugeot-font.css';
import '../../assets/third-party-css/index.css';
import '../../components/carousel/peugeot/peu-controls';
import '../../components/multi-tab-richtext-page/peugeot/peu-multi-tab-richtext-page.elements';
import { peugeotTheme } from '../../styles/peugeot/peugeot-theme';
import { BrandDescriptor, ModuleDescriptor } from './brand-loader';

const peugeotModules: ReadonlyArray<ModuleDescriptor> = Object.freeze([
  {
    externalName: 'VACS',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      await import('../../components/input/slider/general/slider-common');
      await import('../../components/input/text-input/general/contact-form-input-elements');
      await import('../../components/thank-you-page/common/thank-you-page-elements');
      await import('../../../vacs/common/common-vacs');
      return import('../../../vacs/peugeot/peu-vacs').then((vacs) => vacs.VACS);
    },
    labelPrefix: 'vacs',
  },
  {
    externalName: 'Showroom',
    entryPoint: async () => {
      await import('../../../showroom/common/common-showroom');
      return import('../../../showroom/peugeot/peu-showroom').then((showroom) => showroom.ShowroomComponent);
    },
    labelPrefix: 'showroom',
  },
  {
    externalName: 'ModShowroom',
    entryPoint: async () => {
      await import('dompurify');
      await import('../../../showroom/common/common-showroom');
      return import('../../../showroom/peugeot/v2/peu-showroom_v2').then((showroom) => showroom.PeuShowroomV2Component);
    },
    labelPrefix: 'showroom',
  },
  {
    externalName: 'CarSearchWidget',
    entryPoint: async () => {
      await import('../../components/input/slider/general/slider-common');
      await import('../../../car-search-widget/common/common-car-search-widget');
      return import('../../../car-search-widget/peugeot/peu-car-search-widget').then((csw) => csw.CarSearchWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'OfferWidget',
    entryPoint: async () => {
      await import('../../../offer-widget/common/common-offer-widget');
      await import('../../components/single-car-offer/peugeot/single-car-offer');
      return import('../../../offer-widget/peugeot/peu-offer-widget').then((ow) => ow.PeuSingleOfferWidgetComponent);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'WelcomeTextWidget',
    entryPoint: async () => {
      await import('../../../welcome-text/common/common-welcome-text-widget');
      return import('../../../welcome-text/peugeot/peu-welcome-text-widget').then((wtw) => wtw.WelcomeTextWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Location',
    entryPoint: async () => {
      await import('../../components/input/text-input/general/contact-form-input-elements');
      await import('../../components/thank-you-page/common/thank-you-page-elements');
      await import('../../../location/common/common-location');
      await import('../../../location/peugeot/common/peu-common-location');
      return import('../../../location/peugeot/peu-location').then((loc) => loc.LocationPage);
    },
    labelPrefix: 'location',
  },
  {
    externalName: 'Advisor',
    entryPoint: async () => {
      await import('../../../advisor/common/common-advisor');
      return import('../../../advisor/peugeot/peu-advisor').then((adv) => adv.Advisor);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'LocationWidget',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      await import('../../../location/peugeot/common/peu-common-location');
      return import('../../../location/peugeot/peu-location-widget').then((loc) => loc.LocationWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Article',
    entryPoint: async () => {
      await import('../../../article/common/common-article');
      return import('../../../article/peugeot/peu-article').then((art) => art.ArticlePage);
    },
    labelPrefix: 'article',
  },
  {
    externalName: 'AfterSalesWidget',
    entryPoint: async () => {
      await import('../../../after-sales-widget/common/common-after-sales-widget');
      return import('../../../after-sales-widget/peugeot/peu-after-sales-widget').then(
        (afterSalesWidget) => afterSalesWidget.PeuAfterSalesWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'LandingPageWidget',
    entryPoint: async () => {
      await import('../../../landing-page-widget/common/common-landing-page-widget');
      await import('../../components/thank-you-page/common/thank-you-page-elements');
      return import('../../../landing-page-widget/peu/peu-landing-page-widget').then((lap) => lap.PeuLandingPageWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'CommonForm',
    entryPoint: async () => {
      // await import('../../../common/form/controls/text/common-text-input');
      // return import('../../../common/form/common/common-form').then((loc) => loc.CommonForm)
      await import('dompurify');
      await import('classnames');
      await import('resize-observer-polyfill');
      await import('../../../vacs/common/vehicle-list.service');
      return import('../../../common/form/peugeot/peu-form').then((loc) => loc.PeuForm);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Webform',
    entryPoint: async () => {
      await import('dompurify');
      await import('classnames');
      await import('resize-observer-polyfill');
      await import('../../../location/common/common-location');
      await import('../../../common-form-widget/common-form-index-widget');
      return import('../../../common-form-widget/peugeot/peu-common-form-widget').then(
        (form) => form.PeuCommonFormWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidget',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      await import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-image-and-text-widget');
      await import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-downloads-widget');
      await import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-banner-widget');
      return import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-widget').then(
        (spw) => spw.PeugeotStandardProWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-text-widget').then(
        (spw) => spw.PeugeotStandardProWidgetText
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetBanner',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-banner-widget').then(
        (spw) => spw.PeugeotStandardProWidgetBanner
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetDownloads',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-downloads-widget').then(
        (spw) => spw.PeugeotStandardProWidgetDownloads
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetGallery',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-gallery-widget').then(
        (spw) => spw.PeugeotStandardProWidgetGallery
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetImageAndText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-image-and-text-widget').then(
        (spw) => spw.PeugeotStandardProWidgetImageAndTextWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetMultipleImageAndText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-multi-image-and-text-widget').then(
        (spw) => spw.PeugeotStandardProWidgetMultiImageAndText
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetTable',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-table-widget').then(
        (spw) => spw.PeugeotStandardProWidgetTable
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetVideo',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-video-widget').then(
        (spw) => spw.PeugeotStandardProWidgetVideo
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetTabs',
    entryPoint: async () => {
      await import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-image-and-text-widget');
      await import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-downloads-widget');
      await import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-banner-widget');
      await import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-video-widget');
      return import('../../../standard-pro-widget/peugeot/peugeot-standard-pro-tabs-widget').then(
        (spw) => spw.PeugeotStandardProWidgetTabs
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'LeasingAndUsedCarsWidget',
    entryPoint: async () => {
      await import('../../components/input/slider/general/slider-common');
      await import('../../../leasing-and-used-cars-widget/common/common-leasing-and-used-cars-widget');
      return import('../../../leasing-and-used-cars-widget/peugeot/peu-leasing-and-used-cars-widget').then(
        (so) => so.PeuLeasingAndUsedCarsWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'TestPageWidget',
    entryPoint: async () => {
      return import('../../../test-page/peugeot/peu-test-page-widget').then((tpw) => tpw.TestPageWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'BannerWidget',
    entryPoint: async () => {
      return import('../../../banner/peugeot/peugeot-banner-widget').then((banner) => banner.PeuBannerWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'FooterWidget',
    entryPoint: async () => {
      return import('../../../footer/peugeot/peugeot-footer-widget').then((footer) => footer.FooterWidget);
    },
    labelPrefix: 'widget',
  },
]);

export default [peugeotModules, peugeotTheme] as BrandDescriptor;
